import React, { FormEvent, useCallback, useEffect, useState } from "react"
import { SingleLineTextInput, Button } from "dash-styled"
import { LinkButton } from "../../LinkButton/LinkButton"
import { useInput } from "../../../../Hooks/useInput"
import { config } from "bridger"
import { failMessage } from "../../../../Actions/Client/MessagesActions"
import { getSignupError } from "../../../../Helpers/Functions/error"
import { useDispatch } from "react-redux"

export interface FormData {
    email: string
    password: string
}

interface EmailAndPasswordInputRenderContainerProps {
    testId?: string
    prefilledEmail?: string
    onSubmit: (value: FormData) => Promise<void>
    onForgetPassword?: () => void
    submitLabel: string
    emailLabel?: string
    passwordLabel?: string
    disablePasswordPatternValidation: boolean
    errorText?: string
}

export const EmailAndPasswordInputRenderContainer = ({
    prefilledEmail,
    onSubmit,
    onForgetPassword,
    submitLabel,
    emailLabel = "Email",
    passwordLabel = "Password",
    testId,
    disablePasswordPatternValidation,
    errorText = ""
}: EmailAndPasswordInputRenderContainerProps) => {
    const dispatch = useDispatch()
    const email = useInput(prefilledEmail || "", prefilledEmail !== undefined)
    const password = useInput("", false)
    const [error, setError] = useState<string>(errorText)
    const handleSubmit = useCallback(
        (e?: FormEvent) => {
            e?.preventDefault()
            onSubmit({
                email: email.value.toLowerCase(),
                password: password.value
            }).catch(e => {
                const signupError = getSignupError(e)
                if (signupError.displayType === "toast") {
                    dispatch(failMessage(signupError.message, e))
                    setError("")
                } else {
                    setError(signupError.message)
                }
            })
        },
        [onSubmit, email.value, password.value, dispatch]
    )

    useEffect(() => {
        setError("")
    }, [email.value])

    return (
        <form
            onSubmit={handleSubmit}
            data-testid={testId}
            className="flex flex-col items-stretch px-4"
        >
            <SingleLineTextInput
                name="email"
                type="email"
                label={emailLabel}
                value={email.value}
                onChange={email.onChange}
                errorText={error}
                placeholder="me@company.com"
                disabled={prefilledEmail !== undefined}
                className="pb-4"
                testId="email-input"
                required={true}
            />
            <div className="relative">
                <SingleLineTextInput
                    name="password"
                    label={passwordLabel}
                    type="password"
                    value={password.value}
                    onChange={password.onChange}
                    errorText={""}
                    placeholder=""
                    className="pb-4"
                    testId="password-input"
                    required={true}
                    {...(disablePasswordPatternValidation
                        ? {}
                        : {
                              title: config.dash.cognito
                                  .passwordRequirementText,
                              pattern: config.dash.cognito.passwordRegex
                          })}
                />
                {onForgetPassword && (
                    <LinkButton
                        onClick={onForgetPassword}
                        className="absolute right-0 top-0 text-sm my-1"
                        testId="forgot-btn"
                    >
                        Forgot?
                    </LinkButton>
                )}
            </div>
            <Button
                type="submit"
                className="mt-4 w-64 mx-auto"
                testId="submit-button"
            >
                {submitLabel}
            </Button>
        </form>
    )
}
